export default __webpack_public_path__ + "static/media/about_focus.a3296f47.png";